"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contains = exports.reject = exports.select = exports.omitByValue = exports.omit = exports.pickByValue = exports.pickValues = exports.pick = exports.pickKeys = exports.fromEntries = exports.extractEntries = exports.extractValues = exports.extractKeys = void 0;
var guard_1 = require("../guard");
var literal_1 = require("../types/literal");
var is_1 = require("./is");
function extractKeys(obj) {
    return Object.keys(obj);
}
exports.extractKeys = extractKeys;
function extractValues(obj) {
    return Object.values(obj);
}
exports.extractValues = extractValues;
function extractEntries(obj) {
    return Object.entries(obj);
}
exports.extractEntries = extractEntries;
function fromEntries(entries) {
    return Object.fromEntries(entries);
}
exports.fromEntries = fromEntries;
function pickKeys(obj, keyGuardOrKeys) {
    var allKeys = extractKeys(obj);
    return keyGuardOrKeys instanceof guard_1.Guard ? allKeys.filter((0, is_1.is)(keyGuardOrKeys)) : keyGuardOrKeys;
}
exports.pickKeys = pickKeys;
function pick(obj, keyGuardOrKeys, options) {
    if (options === void 0) { options = {}; }
    var skipUndefined = options.skipUndefined;
    if (skipUndefined === true) {
        return pickKeys(obj, keyGuardOrKeys).reduce(function (acc, key) {
            var value = obj[key];
            if (value !== undefined) {
                acc[key] = value;
            }
            return acc;
        }, {});
    }
    else {
        return pickKeys(obj, keyGuardOrKeys).reduce(function (acc, key) {
            acc[key] = obj[key];
            return acc;
        }, {});
    }
}
exports.pick = pick;
function pickValues(obj, keyGuardOrKeys) {
    return pickKeys(obj, keyGuardOrKeys).reduce(function (acc, key) {
        acc.push(obj[key]);
        return acc;
    }, []);
}
exports.pickValues = pickValues;
function pickByValue(obj, valueGuard) {
    var isType = (0, is_1.is)(valueGuard);
    var allKeys = extractKeys(obj);
    return allKeys.reduce(function (acc, key) {
        var value = obj[key];
        if (isType(value)) {
            acc[key] = value;
        }
        return acc;
    }, {});
}
exports.pickByValue = pickByValue;
function omit(obj, keyGuardOrKeys) {
    var allKeys = extractKeys(obj);
    var omittedKeys = keyGuardOrKeys instanceof guard_1.Guard ? allKeys.filter((0, is_1.is)(keyGuardOrKeys)) : keyGuardOrKeys;
    var pickedKeys = allKeys.filter(function (key) { return omittedKeys.includes(key) === false; });
    return pick(obj, pickedKeys);
}
exports.omit = omit;
function omitByValue(obj, valueGuard) {
    var isType = (0, is_1.is)(valueGuard);
    var allKeys = extractKeys(obj);
    return allKeys.reduce(function (acc, key) {
        var value = obj[key];
        if (isType(value) === false) {
            acc[key] = value;
        }
        return acc;
    }, {});
}
exports.omitByValue = omitByValue;
function select(guard) {
    var isType = (0, is_1.is)(guard);
    function itemSelector(iterable) {
        var e_1, _a;
        var selected = [];
        try {
            for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
                var item = iterable_1_1.value;
                if (isType(item)) {
                    selected.push(item);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return selected;
    }
    return itemSelector;
}
exports.select = select;
function reject(valueOrGuard) {
    var isType = valueOrGuard instanceof guard_1.Guard ? (0, is_1.is)(valueOrGuard) : (0, is_1.is)((0, literal_1.literal)(valueOrGuard));
    function itemSelector(iterable) {
        var e_2, _a;
        var selected = [];
        try {
            for (var iterable_2 = __values(iterable), iterable_2_1 = iterable_2.next(); !iterable_2_1.done; iterable_2_1 = iterable_2.next()) {
                var item = iterable_2_1.value;
                if (isType(item) === false) {
                    selected.push(item);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (iterable_2_1 && !iterable_2_1.done && (_a = iterable_2.return)) _a.call(iterable_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return selected;
    }
    return itemSelector;
}
exports.reject = reject;
function contains(valueOrGuard) {
    var isType = valueOrGuard instanceof guard_1.Guard ? (0, is_1.is)(valueOrGuard) : (0, is_1.is)((0, literal_1.literal)(valueOrGuard));
    function itemSelector(iterable) {
        var iterator = iterable[Symbol.iterator]();
        var item = iterator.next();
        while (item.done !== true) {
            if (isType(item.value)) {
                return true;
            }
            item = iterator.next();
        }
        return false;
    }
    return itemSelector;
}
exports.contains = contains;
